<div *ngIf="selectedUser !== undefined; else noSelectedUser" style="margin: 40px 0 0 20px;">
  <div style="display: flex; margin: 40px 0 0 20px;">
    <form [formGroup]="form" style="display: flex;">
      <table style="padding: 10px; border-spacing: 10px;
                  border-collapse: separate;" *ngIf="testMediaDevices">
        <tr>
          <td>
            <label for="device_email"> Email (device: {{getDevice('email')}})</label>
          </td>
          <td style="width: 250px;">
            <span>
              <input
                  style="height: 38px; font-size: 14px;"
                  name="destinatorPhoneEmail"
                  class="form-control"
                  formControlName="destinatorEmail"
                  placeholder="Enter email address"
              />
            <div *ngIf="!isEmailCorrect">Please enter a correct email address</div>
            </span>
          </td>
          <td>
            <button
                class="btn btn-primary"
                style="width: 140px"
                name="sendTestMessage"
                [disabled]="testMediaDevices === undefined || form.controls.destinatorEmail.value === '' || validateTestData()"
                (click)="sendTest('email', selectedUser)">Send Test Email
            </button>
          </td>
        </tr>
        <tr>
          <td>
            <label
                for="device_sms"> Sms (device: {{getDevice('sms')}})</label>
          </td>
          <td style="width: 250px;">
          <span>
              <ngx-intl-tel-input
                  [preferredCountries]="preferredCountries"
                  [enableAutoCountrySelect]="true"
                  [enablePlaceholder]="true"
                  [searchCountryFlag]="true"
                  [selectedCountryISO]="selectedCountryISO$ | async"
                  [selectFirstCountry]="false"
                  [maxLength]="15"
                  [separateDialCode]="true"
                  [phoneValidation]="true"
                  inputId="smsPhoneInput"
                  name="phone"
                  formControlName="destinatorSms"
              ></ngx-intl-tel-input>

          </span>
          </td>
          <td>
            <button
                class="btn btn-primary"
                style="width: 140px"
                name="sendSMS"
                [disabled]="testMediaDevices === undefined ||
            (form.controls.destinatorSms.value === ''|| form.controls.destinatorSms.value === null) || validateTestData()"
                (click)="sendTest('sms', selectedUser)">Send Test SMS
            </button>
          </td>
        </tr>
        <tr>
          <td>
            <label
                for="device_voice"> Voice (device: {{getDevice('voice')}})</label>
          </td>
          <td style="width: 250px;">
          <span>
          <ngx-intl-tel-input
              [preferredCountries]="preferredCountries"
              [enableAutoCountrySelect]="true"
              [enablePlaceholder]="true"
              [searchCountryFlag]="true"
              [selectedCountryISO]="selectedCountryISO$ | async"
              [selectFirstCountry]="false"
              [separateDialCode]="true"
              [maxLength]="15"
              [phoneValidation]="true"
              inputId="voicePhoneInput"
              name="voicePhoneNumber"
              formControlName="destinatorVoice"
              [cssClass]="'tel-input'"
          ></ngx-intl-tel-input>
         </span>
          </td>
          <td>
            <button
                class="btn btn-primary"
                style="width: 140px"
                name="sendVoice"
                [disabled]="testMediaDevices === undefined ||
                (form.controls.destinatorVoice.value === ''|| form.controls.destinatorVoice.value === null) || validateTestData()"
                (click)="sendTest('voice', selectedUser)">Send Test Voice
            </button>
          </td>
        </tr>
      </table>
    </form>
  </div>


  <label style="margin: 40px 0 0 45px; font-size: 16px; font-weight: bold"> Test Settings: <span
      style="font-weight: 600">{{selectedUser.userName || '' }}</span>
    will be used as sender {{appointments.length}}</label>
  <div style="display: flex; margin: 40px 0 0 45px;" *ngFor="let appointment of appointments; let count = index;">
    <label style="margin: 0 16px; font-size: 14px; font-weight: bold"> Appointment {{count + 1 }}: </label>
    <table
        id="previewTestTable"
        style="border-spacing: 10px; width: 50%; text-align: left; border-collapse: collapse; border: 1px solid #eeeeee"
        class="table table-condensed">

      <tr *ngIf="appointment.hasOwnProperty('person.prefix')">
        <td style="width: 35%">person.prefix</td>
        <td style="width: 65%">
          <input type="text" style="height: 38px; font-size: 14px; border: none; box-shadow: none;"
                 class="form-control"
                 placeholder="Enter first name of person"
                 id="person.prefix"
                 [(ngModel)]="appointment['person.prefix']">
        </td>
      </tr>
      <tr>
        <td style="width: 35%">person.firstName</td>
        <td style="width: 65%">
          <input type="text" style="height: 38px; font-size: 14px; border: none; box-shadow: none;"
                 class="form-control"
                 placeholder="Enter first name of person"
                 id="person.firstName"
                 [(ngModel)]="appointment['person.firstName']">
        </td>
      </tr>

      <tr *ngIf="personLocationOptions.length > 0">
        <td style="width: 35%">person.locationId</td>
        <td style="width: 65%">
          <p-dropdown
            [options]="personLocationOptions"
            [(ngModel)]="appointment['person.personLocationId']"
            styleClass="form-control"
            placeholder="Select client location used for adaptive rules"
            optionLabel="label"
            [style]="{'width':'100%', 'background':'white', 'border' : '1px solid #cccccc', 'color' : 'black',
                'padding-left': '16px', 'font-size': '13px', 'text-shadow': 'none'}">
          </p-dropdown>
        </td>
      </tr>

      <tr *ngIf="selectedTemplate.communicationsCategoryId === 'reminder' || containAppointments">
        <td style="width: 35%">appointment.appointmentTime</td>
        <td style="width: 65%">
          <input type="text" style="height: 38px; font-size: 14px; border: none; box-shadow: none;"
                 class="form-control"
                 placeholder="Enter time of appointment"
                 id="appointment.appointmentTime"
                 [(ngModel)]="appointment['appointment.appointmentTime']">
        </td>
      </tr>
      <tr *ngIf="containPets">
        <td style="width: 35%">pet.petName</td>
        <td style="width: 65%">
          <input type="text" style="height: 38px; font-size: 14px; border: none; box-shadow: none;"
                 class="form-control"
                 placeholder="Enter pet name"
                 id="pet.PetName"
                 [(ngModel)]="appointment['pet.petName']">
        </td>
      </tr>
      <tr *ngIf="reasonOptions.length > 0">
        <td style="width: 35%">appointment.reasonId</td>
        <td style="width: 65%">
          <p-dropdown
              [options]="reasonOptions"
              [(ngModel)]="appointment['appointment.reasonId']"
              styleClass="form-control"
              placeholder="Select reason used for adaptive rules"
              optionLabel="label"
              [style]="{'width':'100%', 'background':'white', 'border' : '1px solid #cccccc', 'color' : 'black',
                'padding-left': '16px', 'font-size': '13px', 'text-shadow': 'none'}">
          </p-dropdown>
        </td>
      </tr>
      <tr *ngIf="providerOptions.length > 0">
        <td style="width: 35%">appointment.providerId</td>
        <td style="width: 65%">
          <p-dropdown
              [options]="providerOptions"
              [(ngModel)]="appointment['appointment.providerId']"
              styleClass="form-control"
              placeholder="Select provider used for adaptive rules"
              optionLabel="label"
              [style]="{'width':'100%', 'background':'white', 'border' : '1px solid #cccccc', 'color' : 'black',
                'padding-left': '16px', 'font-size': '13px', 'text-shadow': 'none'}">
          </p-dropdown>
        </td>
      </tr>
      <tr *ngIf="appointmentResourceOptions.length > 0">
        <td style="width: 35%">appointment.resource</td>
        <td style="width: 65%">
          <p-dropdown
              [options]="appointmentResourceOptions"
              [(ngModel)]="appointment['appointment.resource']"
              styleClass="form-control"
              placeholder="Select resource used for adaptive rules"
              optionLabel="label"
              [style]="{'width':'100%', 'background':'white', 'border' : '1px solid #cccccc', 'color' : 'black',
                'padding-left': '16px', 'font-size': '13px', 'text-shadow': 'none'}">
          </p-dropdown>
        </td>
      </tr>
      <tr *ngIf="locationOptions.length > 0">
        <td style="width: 35%">appointment.location</td>
        <td style="width: 65%">
          <p-dropdown
              [options]="locationOptions"
              [(ngModel)]="appointment['appointment.locationObj']"
              (ngModelChange)="setAppointmentLocation(appointment, $event)"
              styleClass="form-control"
              placeholder="Select location used for adaptive rules"
              optionLabel="label"
              [style]="{'width':'100%', 'background':'white', 'border' : '1px solid #cccccc', 'color' : 'black',
                'padding-left': '16px', 'font-size': '13px', 'text-shadow': 'none'}">
          </p-dropdown>
        </td>
      </tr>

    </table>

    <button *ngIf="count === 0 && (containAppointments || containPersons)"
            class="btn btn-primary"
            style="width: 140px; height: 35px; margin: 0 16px;"
            name="addAppointment"
            (click)="addAppointment()">Add Appointment
    </button>

  </div>


  <div style="padding-top: 16px">If a device for the selected media is enabled for the template (in the
    Media/Devices tab) then this will
    be used for sending the test message. Even if the selection is not yet saved. If none selected then the
    default
    will be used account defaults if any defined and otherwise system defaults).
  </div>
</div>

<ng-template #noSelectedUser>
  <div class="error">You need to select a user to send test messages</div>
</ng-template>
